import getType from"./getType";export function isUndefined(payload){return getType(payload)==="Undefined"}export default isUndefined;